<template>
  <div class="block-heading block-link" v-if="componentValue" style="min-height: 40px">
    <div class="placeholder" v-html="htmlText1"></div>
    <textarea v-model="componentValue.link" v-on:keydown="keyDown" placeholder="link"></textarea>
  </div>
  <div class="block-heading block-link" v-if="componentValue" style="min-height: 40px">
    <div class="placeholder" v-html="htmlText2"></div>
    <textarea v-model="componentValue.title" v-on:keydown="keyDown" placeholder="title"></textarea>
  </div>
</template>
<script>
export default {
  props: ["modelValue"],
  data: {
    componentValue: {
      link: "",
      title: "",
    },
  },
  watch: {
    componentValue: {
      handler() {
        if (JSON.stringify(this.componentValue)!=this.modelValue)
          this.$emit("update:modelValue", JSON.stringify(this.componentValue));
      }, deep: true,
    },
    modelValue: {
      handler() {
        if (!this.modelValue)
          return;
        if (JSON.stringify(this.componentValue)!=this.modelValue)
          this.componentValue=JSON.parse(this.modelValue) || {link: "", title: ""};
      }, immediate: true, deep: true,
    },
  },
  mounted() {

  },
  computed: {
    htmlText1() {
      var text=String(this.componentValue.link || "");
      text=text.replace(/\n/g, "<br />\n");
      text=text.replace(/\</g, "&lt;");
      text=text.replace(/\>/g, "&gt;");
      text=text.replace(/"</g, "&quot;");
      text=text.replace(/\&/g, "&amp;");
      return text;
    },
    htmlText2() {
      var text=String(this.componentValue.title || "");
      text=text.replace(/\n/g, "<br />\n");
      text=text.replace(/\</g, "&lt;");
      text=text.replace(/\>/g, "&gt;");
      text=text.replace(/"</g, "&quot;");
      text=text.replace(/\&/g, "&amp;");
      return text;
    }
  },
  methods: {
    keyDown($e) {
      if ($e.keyCode==13) {
        $e.preventDefault();
        this.$emit("new-block", {});
      }
    },
  },
}
</script>
